import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import React from "react";

export const ResultSelectionPicker: ReactTFC<{
  currentIndex: number;
  count: number;
  onIndexRequested: (idx: number) => void;
}> = props => {
  return (
    <div
      css={css`
        width: 100%;
        align-items: center;
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
        `}
      >
        {new Array(props.count).fill(undefined).map((_, idx) => (
          <button
            key={idx}
            className={props.currentIndex === idx ? "active" : undefined}
            onClick={() => props.onIndexRequested(idx)}
            css={css`
              width: 36px;
              height: 36px;

              padding: 14px;
            `}
          >
            <span
              css={css`
                background-color: ${CSS_COLORS.Grey};

                .active & {
                  background-color: ${CSS_COLORS.Green};
                }

                border-radius: 100%;

                width: 100%;
                height: 100%;
                display: block;
              `}
            />
          </button>
        ))}
      </div>
    </div>
  );
};
